import GeneralImageNew from '@gp/components/GeneralImageNew';
import { MilestoneDateStatus } from '@gp/enums/milestone';
import { formatDateStr, getTencentAvatarSrc } from '@gp/utils/common';
import { formatMilestoneDateByStatus } from '@gp/utils/milestone';
import classnames from 'classnames';
import React from 'react';

import type { IBaseProps } from '@home/types/common';

import './index.scss';

export interface IChangeLog {
  dateConfirm?: MilestoneDateStatus;
  date?: string;
  reason?: string;
  updateUser?: string;
  updateTime?: string;
}

interface IChangeLogsProps extends IBaseProps {
  data?: IChangeLog[];
}

const getUpdateSummaryDesc = (updateUser?: string, updateTime?: string): string => {
  if (!updateUser && !updateTime) return '';
  const updateTimeFormatted = formatDateStr(updateTime, 'YYYY-MM-DD HH:mm:ss');
  if (!updateUser) return `Updated on ${updateTimeFormatted}`;
  return `${updateUser} updated on ${updateTimeFormatted}`;
};

const ChangeLogs: React.FC<IChangeLogsProps> = (props) => {
  const { style, className, data } = props;

  return (
    <div
      style={style}
      className={classnames('dbg-change-logs dbg-word-break-wrap', className)}
      onClick={(e) => {
        e?.stopPropagation();
      }}
      onScroll={(e) => {
        e?.stopPropagation();
      }}
    >
      <div className="dbg-change-logs-title">Milestone updated in the past 30 days</div>
      <div className="dbg-change-logs-list">
        {data?.map((item, idx) => {
          const { dateConfirm, date, reason, updateUser, updateTime } = item || {};
          const reasonTrim = reason?.trim() || '';
          return (
            <div key={idx} className="dbg-change-logs-list-item dbg-change-log">
              <div className="dbg-change-log-header">
                <span className="dbg-change-log-header-date">
                  {formatMilestoneDateByStatus(date, dateConfirm) || '-'}
                </span>
                {dateConfirm === MilestoneDateStatus.ToBeConfirm && (
                  // <img className="dbg-change-log-header-icon-tbc" src={ICON_TBC} />
                  <span className="dbg-calendar-milestone-bubble-tbc">TBC</span>
                )}
              </div>
              {reasonTrim && (
                <div className="dbg-change-log-body">
                  <span className="dbg-change-log-body-inner">{reasonTrim}</span>
                </div>
              )}
              <div className="dbg-change-log-footer">
                <GeneralImageNew
                  className="dbg-change-log-footer-avatar"
                  domain="user"
                  width={16}
                  height={16}
                  src={getTencentAvatarSrc(updateUser)}
                />
                <span className="dbg-change-log-footer-desc">
                  {getUpdateSummaryDesc(updateUser, updateTime)}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ChangeLogs;
